import React from "react";
import { Box, Typography, Chip } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

const ServiceDetails = ({ service }) => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>
        {service.service} (Service No: {service.service_no})
      </Typography>

      <Typography variant="body1">Unit Cost: ${service.unit_cost}</Typography>
      <Typography variant="body1">Status: {service.status === "1" ? "Active" : "Inactive"}</Typography>

      {/* Consent Form */}
      <Chip
        icon={service.has_consent_treatment === "1" ? <CheckCircleIcon /> : <CancelIcon />}
        label={service.has_consent_treatment === "1" ? "Consent Form Available" : "No Consent Form"}
        color={service.has_consent_treatment === "1" ? "success" : "error"}
        sx={{ mt: 1, mr: 1 }}
      />

      {/* Subservices */}
      <Typography variant="h6" sx={{ mt: 2 }}>
        Subservices:
      </Typography>
      {service.service_subtypes.map((subtype, index) => (
        <Chip key={index} label={subtype} color="primary" sx={{ mr: 1, mt: 1 }} />
      ))}
    </Box>
  );
};

export default ServiceDetails;
